import { HttpInterceptorFn, HttpParams } from '@angular/common/http';

export const cleanHttpParamsInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.params || !req.params.keys().length) {
    return next(req);
  }

  let cleanedParams = new HttpParams();

  req.params.keys().forEach(key => {
    const value = req.params.get(key);

    if (isValidValue(value)) {
      cleanedParams = cleanedParams.set(key, value!);
    }
  });
  const newRequest = req.clone({ params: cleanedParams });

  return next(newRequest);
};

function isValidValue(value: string | null): boolean {
  const invalidStringValues = ['undefined', 'null'];
  return !!(value && !invalidStringValues.includes(value));
}
